function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.607 4.452a1 1 0 00-1.415 0L9.804 5.84l2.828 2.829 1.389-1.389a1 1 0 000-1.414l-1.414-1.414zm-.682 4.924L9.096 6.548l-6.389 6.389a1 1 0 000 1.414l1.414 1.414a1 1 0 001.415 0l6.389-6.389z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.207 2.037L7.793 3.451M16.707 9.038l-1.414 1.414M16.414 2.744L15 4.158M9.207 3.45L7.793 2.038M16.707 10.451l-1.414-1.414M16.414 4.158L15 2.743",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));